import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Column, Text } from '../../theme/index';
import moment from 'moment';

const Wrapper = styled.div`
  background-color: white;
  border-radius: 4px;
  padding: 30px;
  position: relative;
  overflow: hidden;
  width: 100%;
  display: flex;
  outline: none;
  -webkit-box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.03);
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.03);
  border: 1px solid #d4dadf;
  margin: 1em 0;
  @media (max-width: 720px) {
    flex-direction: column;
    align-items: center;
    padding: 30px 0;
  }
`;

const Image = styled.img`
  margin-right: 2em;
  @media (max-width: 720px) {
    margin-right: 0;
  }
`;

const StyledColumn = styled(Column)`
  @media (max-width: 720px) {
    margin-left: 1em;
    margin-top: 1em;
    width: 90%;
  }
`;

export default function Post({ post }) {
  return (
    <Link to={`/resources/${post.id}`} className="Home-link">
      <Wrapper>
        <Image
          alt={post.title}
          className="Home-img"
          src={`https://media.graphcms.com/resize=w:200,h:200,fit:crop/${
            post.mainArtwork.handle
          }`}
        />
        <StyledColumn>
          <Text protitle>{post.title}</Text>
          <Text instructortitle>{moment(post.date).format('MMM Do YY')}</Text>
          <Text>{post.excerpt}</Text>
        </StyledColumn>
      </Wrapper>
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/components/screens/Resources/Post.jsx